/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
import { useState, useEffect } from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { DialogHeader } from "@repo/ui";
import { useGetTicketsByLocation } from "services/tickets";
// eslint-disable-next-line import/order
import { Loader } from "@progress/kendo-react-indicators";

export default function TicketsByLocation({ servicePointId }) {
  const [tickets, setTickets] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const pageSize = 5;
  const {
    mutate: getTickets,
    data: ticketsList,
    error: getTicketsError,
    reset: resetGetTickets,
    isPending: gettingTickets,
  } = useGetTicketsByLocation();

  useEffect(() => {
    if (ticketsList) {
      setTotalRecords(ticketsList.data.totalRecords);
      setTickets(ticketsList.data.data);
      resetGetTickets();
    }
  }, [ticketsList]);

  useEffect(() => {
    getTickets({
      assetId: servicePointId,
      pageNumber: 1,
      pageRowCount: pageSize,
    });
  }, []);
  const onPageChange = (e) => {
    const _page = e.page.skip / pageSize + 1;
    setCurrentPage(_page);
    getTickets({
      assetId: servicePointId,
      pageNumber: _page,
      pageRowCount: pageSize,
    });
  };
  if (getTicketsError && getTicketsError.status === 403) {
    return <>User is not authorized to view records</>;
  }
  return (
    <>
      <DialogHeader>Tickets List</DialogHeader>
      {/* <FilterBarV2
        hideAsset={true}
        getTicketList={(
          filter,
          selectedDate,
          selectedCashCenter,
          selectedCustomer,
          selectedLocation,
          selectedReason
        ) => {
          setFilters({
            searchCriteria: filter,
            operationDate: selectedDate,
            cashCenterId: selectedCashCenter,
            customerId: selectedCustomer,
            assetId: servicePointId,
            reasons: selectedReason,
          });
        }}
      /> */}
      {gettingTickets ? <Loader /> : <></>}
      <Grid
        data={tickets || []}
        className="list-tables-v1"
        style={{ overflow: "hidden" }}
        filterable
        width="100%"
        sortable
        pageable
        total={totalRecords}
        pageSize={pageSize}
        skip={(currentPage - 1) * pageSize}
        onPageChange={onPageChange}
      >
        <GridColumn
          title="Case Number"
          field="caseNo"
          width="170px"
          // filterable={false}
          // cell={({ dataItem }) => (
          //   <td>
          //     <Link
          //       to={
          //         dataItem.status === "Draft"
          //           ? `${PATHS.createTicket}/${dataItem.ticketId}`
          //           : `${PATHS.ticketDetails}/${dataItem.ticketId}`
          //       }
          //     >
          //       {dataItem.status === "Draft" ? "View Draft" : dataItem.caseNo}
          //     </Link>
          //   </td>
          // )}
        />
        <GridColumn
          title="Bank Reference No"
          field="customerTicketNo"
          width="200px"
        />
        <GridColumn title="Account" field="customer" width="170px" />
        <GridColumn title="Asset Id" field="locationId" width="150px" />
        <GridColumn title="Location" field="locationName" width="170px" />
        <GridColumn title="Activity Type" field="activityType" width="170px" />
        <GridColumn title="Category" field="category" width="150px" />
        <GridColumn title="Sub Category" field="subCategory" width="150px" />
        <GridColumn
          title="Assignment Group"
          field="assignmentGroup"
          width="170px"
        />
        <GridColumn
          title="State"
          field="status"
          width="200px"
          className="text-center"
          headerClassName="text-center"
        />
        <GridColumn title="Region" field="region" width="150px" />
        <GridColumn title="Description" field="remarks" width="170px" />
        <GridColumn
          title="Created Al"
          field="createDateTime"
          width="120px"
          className="text-center"
          headerClassName="text-center"
        />
        {/* <GridColumn
title={"Assigned To"}
field={"assignmentGroup"}
width={"170px"}
></GridColumn> */}
      </Grid>
    </>
  );
}
